import { Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

export const RUTA_COMPLETAR_REGISTRO = "/completar-registro";

// Mientras el usuario logueado tenga el perfil incompleto (alta por Google/Facebook sin
// terminar de cargar sus datos) NINGUNA página es navegable salvo la de completar el
// registro. Como envuelve a <Routes>, también cubre cerrar la pestaña y volver: la marca
// perfil_incompleto viaja en el user que se rehidrata y se refresca desde /auth/me.
//
// El backend lo refuerza igual (403 code=perfil_incompleto en carrito, pedidos, etc.),
// esto es lo que evita que el usuario vea una pantalla vacía o un error.
const PerfilIncompletoGate = ({ children }) => {
  const incompleto = useSelector((state) => !!state.auth.token && !!state.auth.user?.perfil_incompleto);
  const { pathname } = useLocation();
  const destino = process.env.PUBLIC_URL + RUTA_COMPLETAR_REGISTRO;

  if (incompleto && pathname !== destino) {
    return <Navigate to={destino} replace />;
  }

  return children;
};

export default PerfilIncompletoGate;
